import { useEffect } from 'react';
import { useLayout } from '@/contexts/LayoutContext';
import { useTheme } from '@/contexts/ThemeContext';
import { getLayout3ThemeStyle } from './theme';

const WL3_THEME_KEYS = [
  '--wl3-accent',
  '--l3-accent',
  '--wl3-primary',
  '--wl3-secondary',
  '--wl3-button',
  '--wl3-title',
  '--wl3-text',
  '--wl3-muted',
  '--wl3-header',
  '--wl3-menu',
  '--wl3-accent-bg',
] as const;

/** Injeta variáveis WL3 no :root quando o layout 3 está ativo (evita reset por `.layout-3` aninhado). */
export function Layout3ThemeSync() {
  const { currentLayout } = useLayout();
  const { colors } = useTheme();

  useEffect(() => {
    const root = document.documentElement;
    const isLayout3 = currentLayout === 'layout-3';

    if (!isLayout3) {
      WL3_THEME_KEYS.forEach((key) => root.style.removeProperty(key));
      return;
    }

    const style = getLayout3ThemeStyle(colors);
    Object.entries(style).forEach(([key, value]) => {
      if (typeof value === 'string') {
        root.style.setProperty(key, value);
      }
    });

    return () => {
      WL3_THEME_KEYS.forEach((key) => root.style.removeProperty(key));
    };
  }, [currentLayout, colors]);

  return null;
}
